import React from "react";

const formatPhone = (value) => {
  if (!value) return '';

  const raw = value.trim();
  const hasPlus = raw.startsWith('+');

  let digits = raw.replace(/\D/g, '');

  // 👇 caso só "+"
  if (hasPlus && digits.length === 0) return '+';

  if (!digits) return '';

  // 🔍 detecta DDI
  const isBrazil = digits.startsWith('55');

  // 🌍 INTERNACIONAL (tem + e NÃO é Brasil)
  if (hasPlus && !isBrazil) {
    digits = digits.slice(0, 15);
    return `+${digits}`;
  }

  // 🇧🇷 BRASIL (com ou sem +55)
  if (isBrazil) {
    digits = digits.slice(2);
  }

  digits = digits.slice(0, 11);

  const ddd = digits.slice(0, 2);
  const number = digits.slice(2);

  if (digits.length <= 2) return `+55 (${ddd}`;

  if (number.length <= 8) {
    if (number.length <= 4) {
      return `+55 (${ddd}) ${number}`;
    }
    return `+55 (${ddd}) ${number.slice(0, 4)}-${number.slice(4)}`;
  }

  if (number.length <= 9) {
    if (number.length <= 5) {
      return `+55 (${ddd}) ${number}`;
    }
    return `+55 (${ddd}) ${number.slice(0, 5)}-${number.slice(5)}`;
  }

  return `+55 (${ddd}) ${number.slice(0, 5)}-${number.slice(5, 9)}`;
};

const formatWhatsAppText = (text) => {
if (!text) return null;

  // 🔗 Detecta links
  const linkRegex = /(https?:\/\/[^\s]+)/g;

  // 🎯 Divide linhas
  const lines = text.split("\n");

  const renderInline = (str, keyPrefix = "") => {
    let elements = [];
    let i = 0;
    let buffer = "";

    const pushBuffer = () => {
      if (!buffer) return;

      // link detection dentro do texto
      const parts = buffer.split(linkRegex);

      parts.forEach((part, idx) => {
        if (linkRegex.test(part)) {
          elements.push(
            <a
              key={`${keyPrefix}-link-${i}-${idx}`}
              href={part}
              target="_blank"
              rel="noreferrer"
              style={{ color: "#0b93f6" }}
            >
              {part}
            </a>
          );
        } else {
          elements.push(part);
        }
      });

      buffer = "";
    };

    while (i < str.length) {
      const char = str[i];

      // 🎯 BOLD *
      if (char === "*") {
        pushBuffer();
        let end = str.indexOf("*", i + 1);
        if (end !== -1) {
          elements.push(
            <strong key={`${keyPrefix}-b-${i}`}>
              {renderInline(str.slice(i + 1, end), keyPrefix + "-b")}
            </strong>
          );
          i = end + 1;
          continue;
        }
      }

      // 🎯 ITALIC _
      if (char === "_") {
        pushBuffer();
        let end = str.indexOf("_", i + 1);
        if (end !== -1) {
          elements.push(
            <em key={`${keyPrefix}-i-${i}`}>
              {renderInline(str.slice(i + 1, end), keyPrefix + "-i")}
            </em>
          );
          i = end + 1;
          continue;
        }
      }

      // 🎯 STRIKE ~
      if (char === "~") {
        pushBuffer();
        let end = str.indexOf("~", i + 1);
        if (end !== -1) {
          elements.push(
            <del key={`${keyPrefix}-s-${i}`}>
              {renderInline(str.slice(i + 1, end), keyPrefix + "-s")}
            </del>
          );
          i = end + 1;
          continue;
        }
      }

      // 🎯 INLINE CODE `
      if (char === "`") {
        pushBuffer();
        let end = str.indexOf("`", i + 1);
        if (end !== -1) {
          elements.push(
            <code key={`${keyPrefix}-c-${i}`} style={codeStyle}>
              {str.slice(i + 1, end)}
            </code>
          );
          i = end + 1;
          continue;
        }
      }

      buffer += char;
      i++;
    }

    pushBuffer();

    return elements;
  };

  const blocks = [];

  let i = 0;

  while (i < text.length) {
    // 📦 BLOCO ``` ```
    if (text.slice(i, i + 3) === "```") {
      let end = text.indexOf("```", i + 3);

      if (end !== -1) {
        const code = text.slice(i + 3, end);

        blocks.push(
          <pre key={`block-${i}`} style={preStyle}>
            {code}
          </pre>
        );

        i = end + 3;
        continue;
      }
    }

    // texto normal (linha por linha)
    let nextBlock = text.indexOf("```", i);
    let slice = nextBlock === -1 ? text.slice(i) : text.slice(i, nextBlock);

    const localLines = slice.split("\n");

    localLines.forEach((line, idx) => {
      blocks.push(
        <div key={`line-${i}-${idx}`} style={{ marginBottom: 2 }}>
          {renderInline(line, `line-${i}-${idx}`)}
        </div>
      );
    });

    i = nextBlock === -1 ? text.length : nextBlock;
  }

  return <div style={{ wordBreak: "break-word" }}>{blocks}</div>;
};

/* 🎨 estilos */
const codeStyle = {
  background: "#f0f0f0",
  padding: "2px 4px",
  borderRadius: 4,
  fontSize: 13,
  fontFamily: "monospace"
};

const preStyle = {
  background: "#f0f0f0",
  padding: 10,
  borderRadius: 8,
  fontSize: 13,
  fontFamily: "monospace",
  overflowX: "auto"
};
export  {formatPhone,formatWhatsAppText};